import { jsxs, jsx } from 'react/jsx-runtime';
import { useAppState } from '../../context/AppContext.js';
import { useAppConfiguration } from '../../context/useAppConfiguration.js';
import { useTranslations } from '../../translations/index.js';
import styles from './Flyout.module.css.js';

const Flyout = ({ id, labelId, visible, elementRef }) => {
    const { t } = useTranslations();
    const { isLoggedIn, hasBonusPoints, domain } = useAppState();
    const { customerConfiguration: { displayWishlist, displayCoupons, couponsCount }, } = useAppConfiguration({ domain });
    const accountOverview = { href: '/account/overview', text: t('overview') };
    const orders = { href: '/account/orders/overview', text: t('order.overview') };
    const reorder = { href: '/account/orders/reorder', text: t('reorder') };
    const wishlist = { href: '/account/wishlist', text: t('wishlist') };
    const bonuspoints = { href: '/account/bonuspoints/products/overview', text: t('bonusprogram') };
    const coupons = {
        href: '/account/coupons/overview',
        text: t('coupons'),
        couponsCount,
        displayCouponsCount: Number.isInteger(couponsCount),
    };
    const accountLinks = [
        accountOverview,
        orders,
        reorder,
        displayWishlist && wishlist,
        hasBonusPoints && bonuspoints,
        displayCoupons && coupons,
    ].filter(Boolean);
    return (jsxs("div", { id: id, role: "menu", "aria-labelledby": labelId, "aria-hidden": !visible, ref: elementRef, className: visible ? styles.flyoutVisible : styles.flyout, children: [accountLinks.map((link) => (jsx("a", { href: link.href, role: "menuitem", "aria-label": link.text, className: styles.link, rel: "nofollow", children: jsxs("span", { className: styles.linkText, children: [link.text, link.displayCouponsCount && jsx("span", { className: styles.badge, children: link.couponsCount })] }) }, link.href))), isLoggedIn && (jsx("a", { href: "/checkout/logout.htm", role: "menuitem", className: styles.logoutLink, children: t('logout') }))] }));
};
Flyout.displayName = 'Flyout';

export { Flyout as default };
//# sourceMappingURL=Flyout.js.map
